<ng-container *ngIf="isAuthStateLoaded(); else loading">
  <mat-sidenav-container class="main-layout">
    <mat-sidenav #sidenav mode="side" opened="false">
      <!-- Opcional: contenido de menú lateral -->
    </mat-sidenav>

    <mat-sidenav-content>
      <app-navbar *ngIf="showNavbar()"></app-navbar>
      <app-impersonation-banner *ngIf="showNavbar()"></app-impersonation-banner>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
      <footer class="app-footer" *ngIf="showNavbar()">
        <span class="app-footer-copy">© 2026 {{ marca.nombre }}</span>
        <span class="app-footer-sep">·</span>
        <button mat-button class="app-footer-link" (click)="openLegal('privacidad')">Política de Privacidad</button>
        <span class="app-footer-sep">·</span>
        <button mat-button class="app-footer-link" (click)="openLegal('condiciones')">Términos de Uso</button>
        <span class="app-footer-sep">·</span>
        <button mat-button class="app-footer-link" (click)="openLegal('cookies')">Cookies</button>
        <span class="app-footer-spacer"></span>
        <span class="app-footer-version">v{{ appVersion }}</span>
      </footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>

<ng-template #loading>
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</ng-template>